type PostOptions = {
  abortSignal?: AbortSignal;
};

type HTTPPost = (
  url: string,
  data: Record<string, unknown>,
  options?: PostOptions,
) => Promise<Record<string, unknown>>;

export type FetchErrorOptions = {
  response?: any;
  status?: number;
};

export class FetchError extends Error {
  response: any;
  status: number | undefined;

  constructor(message: string, { status, response }: FetchErrorOptions = {}) {
    super(message);
    this.name = "FetchError";
    this.response = response;
    this.status = status;
  }
}

export const post = function (
  url: string,
  data?: Record<string, unknown>,
  options: PostOptions = {},
) {
  return fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data || {}),
    signal: options?.abortSignal,
    credentials: "include",
  }).then((response) => {
    return response.json().then(function (decoded) {
      if (!response.ok) {
        throw new FetchError(`POST request to ${url} failed`, {
          status: response.status,
          response: decoded,
        });
      }
      return decoded;
    });
  });
};

export const postRaw = function (url: string, data?: string) {
  return fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/octet-stream" },
    body: data,
  }).then((response) => {
    return response.json().then(function (decoded) {
      if (!response.ok) {
        throw new FetchError(`POST request to ${url} failed`, {
          status: response.status,
          response: decoded,
        });
      }
      return decoded;
    });
  });
};

export const put = function (url: string, data?: Record<string, unknown>) {
  return fetch(url, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  }).then((response) => {
    return response.json().then(function (decoded) {
      if (!response.ok) {
        throw new FetchError(`PUT request to ${url} failed`, {
          status: response.status,
          response: decoded,
        });
      }
      return decoded;
    });
  });
};

export const httpDelete = function (
  url: string,
  data?: Record<string, unknown>,
) {
  return fetch(url, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  }).then((response) => {
    if (!response.ok) {
      throw new FetchError(`DELETE request to ${url} failed`, {
        status: response.status,
      });
    }
    return response.json();
  });
};

export const get = function (url: string) {
  return fetch(url, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  }).then((response) => {
    if (!response.ok) {
      throw new FetchError(`GET request to ${url} failed`, {
        status: response.status,
      });
    }
    return response.json();
  });
};
